import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

import Menu from "../components/salones/Menu.js";
import Footer from "../components/salones/Footer.js";
import WebDemo from "../components/salones/WebDemo.js";

const SalonesDemos = () => {
	const { t } = useTranslation();

	useEffect(() => {
		document.documentElement.classList.add("beauty-bg");
		document.body.classList.add("beauty-bg");
		return () => {
			document.documentElement.classList.remove("beauty-bg");
			document.body.classList.remove("beauty-bg");
		};
	}, []);

	return (
		<div style={{ backgroundColor: "#000" }}>
			<Helmet>
				<title>{t("seo.beautyDemo.title")}</title>
				<meta name="description" content={t("seo.beautyDemo.description")} />
				<link rel="canonical" href="https://applaby.com/salones/demo" />
			</Helmet>

			<Menu />
			<WebDemo />
			<Footer />
		</div>
	);
};

export default SalonesDemos;
